import * as z from 'zod';
import { bidSuretyBondClosedReasonSchema, finalContractSuretyBondFormTypeSchema } from '../../../../enums.mjs';
import { rateSchema, isoDateSchema } from '../../../opaque.mjs';
import { currencySchema } from '../../../utils.mjs';
import { Data as Data$1 } from './contract-surety-bond.types.mixins.mjs';

var Data;
(function (Data) {
    Data.schema = Data$1.baseSchema.extend({
        contractSuretyType: z.literal("bid"),
        bidAmount: currencySchema,
        bidDate: isoDateSchema,
        finalBondFormType: finalContractSuretyBondFormTypeSchema.nullish(),
        finalBondContingentRate: rateSchema,
        finalBondContingentRateTemplateVersion: z.string(),
        finalBondContingentPremium: currencySchema,
        closedReason: bidSuretyBondClosedReasonSchema.nullish(),
        tListingRequired: z.boolean(),
        isFinalBondCompletionBond: z.boolean(),
    });
})(Data || (Data = {}));
var Close;
(function (Close) {
    (function (Payload) {
        Payload.baseSchema = z.object({
            suretyType: z.literal("contract"),
            contractSuretyType: z.literal("bid"),
            closedNote: z.string().optional(),
        });
        Payload.bidCompletedReasonsSchema = Payload.baseSchema.omit({ closedNote: true }).extend({
            closedReason: bidSuretyBondClosedReasonSchema.extract(["bid_lost", "not_awarded"]),
        });
        Payload.allOtherReasonsSchema = Payload.baseSchema.extend({
            closedReason: bidSuretyBondClosedReasonSchema.extract([
                "input_error",
                "returned_by_obligee",
                "other",
            ]),
            closedNote: z.string(),
        });
        Payload.schema = z.discriminatedUnion("closedReason", [
            Payload.bidCompletedReasonsSchema,
            Payload.allOtherReasonsSchema,
        ]);
    })(Close.Payload || (Close.Payload = {}));
})(Close || (Close = {}));

export { Close, Data };
